import {NgOptimizedImage} from '@angular/common';
import {ChangeDetectionStrategy, Component, effect, EffectRef, inject, signal, untracked, WritableSignal} from '@angular/core';
import {LayoutService} from '../../services/layout.service';
import {CustomerService} from '../../services/customer.service';
import {TranslatePipe} from '../../pipes/translate.pipe';
import {CustomerBrandingResource} from '../../types/generated/customerBrandingResource';
import {FileStorageResource} from '../../types/generated/fileStorageResource';

@Component({
    selector: 'app-customer-icon',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgOptimizedImage, TranslatePipe],
    template: `
    <img 
      [ngSrc]="useCustomerIconFallback() ? layoutService.getLogoByTheme() : getCustomerLogoPath()" 
      [width]="300" 
      [height]="107"
      [alt]="('CUSTOMERIMAGE' | translate)" 
      (error)="useCustomerIconFallback.set(true)"
      class="img-fluid" 
      priority 
    />
  `
})
export class CustomerIconComponent {
  public layoutService: LayoutService = inject(LayoutService);
  public customerService: CustomerService = inject(CustomerService);

  public useCustomerIconFallback: WritableSignal<boolean> = signal<boolean>(false);

  public getCustomerLogoPath(): string {
    const branding = this.customerService.publicCustomerResource()?.branding;
    const logo = this.getLogoByTheme(branding);

    return logo?.path ?? this.getLegacyLogo(branding)?.path ?? '';
  }

  private retriggerFallback: EffectRef = effect( () => {
    if(this.getCustomerLogoPath()) {
      untracked(() => { this.useCustomerIconFallback.set(false)});
    }
  });

  private getLogoByTheme(branding: CustomerBrandingResource | undefined): FileStorageResource | undefined {
    return this.layoutService.getTheme() === 'dark'
      ? branding?.logo?.dark_mode
      : branding?.logo?.light_mode;
  }

  private getLegacyLogo(branding: CustomerBrandingResource | undefined): FileStorageResource | undefined {
    return (branding as (CustomerBrandingResource & {file?: FileStorageResource}) | undefined)?.file;
  }
}
